import ResourceService from 'src/modules/resource/resourceService';
import Errors from 'src/modules/shared/error/errors';

const prefix = 'RESOURCE_TREE';

const resourceTreeActions = {
  FETCH_STARTED: `${prefix}_FETCH_STARTED`,
  FETCH_SUCCESS: `${prefix}_FETCH_SUCCESS`,
  FETCH_ERROR: `${prefix}_FETCH_ERROR`,
  EXPAND_STARTED: `${prefix}_EXPAND_STARTED`,
  EXPAND_SUCCESS: `${prefix}_EXPAND_SUCCESS`,
  EXPAND_ERROR: `${prefix}_EXPAND_ERROR`,
  EXPAND_COLLAPSED: `${prefix}_EXPAND_COLLAPSED`,
  RESETED: `${prefix}_RESETED`,

  doReset: () => async (dispatch) => {
    dispatch({ type: resourceTreeActions.RESETED });
  },

  doFetch:
    (focusId: string | null) =>
    async (dispatch) => {
      try {
        dispatch({
          type: resourceTreeActions.FETCH_STARTED,
          payload: { focusId },
        });

        const response = await ResourceService.treeFocus(
          focusId,
        );

        dispatch({
          type: resourceTreeActions.FETCH_SUCCESS,
          payload: { focusId, response },
        });
      } catch (error) {
        Errors.handle(error);
        dispatch({
          type: resourceTreeActions.FETCH_ERROR,
          payload: { focusId },
        });
      }
    },

  doExpand:
    (nodeId: string) =>
    async (dispatch) => {
      try {
        dispatch({
          type: resourceTreeActions.EXPAND_STARTED,
          payload: { nodeId },
        });

        const response = await ResourceService.treeFocus(
          nodeId,
        );

        dispatch({
          type: resourceTreeActions.EXPAND_SUCCESS,
          payload: {
            nodeId,
            children: response?.children ?? [],
          },
        });
      } catch (error) {
        Errors.handle(error);
        dispatch({
          type: resourceTreeActions.EXPAND_ERROR,
          payload: { nodeId },
        });
      }
    },

  doCollapse:
    (nodeId: string) =>
    async (dispatch) => {
      dispatch({
        type: resourceTreeActions.EXPAND_COLLAPSED,
        payload: { nodeId },
      });
    },
};

export default resourceTreeActions;
